<template>
  <apartment-bulk-add-blank-form
    submit-label="Массово добавить квартиры"
    :apartment="apartment"
    :errors="errors"
    form-type="add"
    @submit="processApartmentForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { bulkAddClients } from '@/services/client.service'
import apartmentBulkAddBlankForm from '@/components/forms/apartment/ApartmentBulkAddBlankForm'

export default {
  name: 'apartment-bulk-add-form',
  components: { apartmentBulkAddBlankForm },
  props: {
    block: {
      type: [Number]
    }
  },
  data () {
    return {
      apartment: {
        id: null,
        apartment_number_from: '',
        apartment_number_to: '',
        block: this.block,
        contract_number_prefix: ''
      },

      errors: {
        apartment: {
          id: [],
          apartment_number_from: [],
          apartment_number_to: [],
          block: [],
          contract_number_prefix: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processApartmentForm () {
      this.bulkAddClients().then((success) => {
        if (success) {
          this.showMsg('Квартиры были успешно добавлены!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    bulkAddClients () {
      return bulkAddClients(this.apartment).then((response) => {
        this.apartment = response.data
        this.fillErrors(this.errors.apartment, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.apartment, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ApartmentBulkAddForm.vue?5eaa02fb